import headerDImgSrc from './assets/key-art.png';
import headerMBImgSrc from './assets/key-art-m.png';
import aboutWalkImgSrc from './assets/intro-photo.png';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { JSDCContext, JSDCProvider } from './JSDC/Context';
import JSDC from './JSDC';
import { latLng } from 'leaflet';
import { IDuiContextProviderProps, DuiContextProvider } from './components/Context';
import DguideWalksApp from './components/DguideWalksApp';
// import { baseUrl } from "./icon"
import { DguidewalksProvider } from './JSDC/Dguidewalks/Context';
import { GeoJsonProperties } from 'geojson';
import ResponsiveDialog from './components/ResponsiveDialog';
import TrailCard, { ITrailCardProps } from './components/LeafletPopup/TrailCard';
import { get, mapKeys, pick } from 'lodash';
import { getCityAndTown } from './service-worker';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import ConfigProvider from './JSDC/Dguidewalks/ConfigProvider';
import ApiProvider from './JSDC/Dguidewalks/ApiProvider';
import ArticleProxyParser from './JSDC/Dguidewalks/proxyParser';
import { Article } from './JSDC/Dguidewalks/proxyParser/@types';
import { EndPoint } from './apiConfigs';

const EVENT_ID = 'n0008';

// 環境紀錄配置
const config = new ConfigProvider({
  eventId: EVENT_ID,
  cmsPath: [], // 空陣列表示不篩選，顯示所有景點
});

const articleParser = new ArticleProxyParser({
  proxyFetcher: new ApiProvider(config).getProxyQuery,
  cmsPath: [], // 空陣列表示不篩選，顯示所有景點
  apiUrls: [EndPoint.Trail.ALL, EndPoint.AdvanceListing.ALL],
});

const aboutWalkContent = `
<h3 style="text-align: center; color: var(--dui-bg-accent);">
台灣河溪守護網
<br/>
<a href="https://iriver.tw/" target='_blank' style='color: var(--dui-bg-accent); text-decoration: none;'>
(https://iriver.tw/)
</a>
</h3>
`;

const credit = `
本平臺由社團法人台灣河溪網協會所建置，並提供全國民眾使用，若有其他利用或授權需求請洽<b><a href="mailto:service@twrna.org" target='_blank' style='color: darkgreen;'>社團法人台灣河溪網協會</a></b>。`;

const handleSceneNavigate = (title: string, latitude?: number, longitude?: number) => {
  // 開啟 Google Maps 導航
  if (latitude !== undefined && longitude !== undefined) {
    // 使用坐標導航
    window.open(`https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`);
  } else {
    // 無坐標時使用景點名稱搜尋
    window.open(`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(title)}`);
  }
};

// type ForExactLayerNameOptions = {
//   Jsdc: JSDC
//   layerName: string
//   featureName: string
// }

// function forExactLayerName<L extends Marker>(
//   { Jsdc, layerName, featureName }: ForExactLayerNameOptions,
//   cb: (layer: L) => void
// ) {
//   const targetFeature = Jsdc.Controller.get("Layer")
//     .getByName(layerName)
//     ?.isGeoJSON();
//   if (!targetFeature) return;
//   const layers = targetFeature.instance.getLayers() as L[];
//   for (const layer of layers) {
//     const layerName = layer.feature?.properties.name;
//     if (!layerName) continue;
//     if (featureName.includes(String(layerName))) {
//       cb(layer);
//       break;
//     }
//   }
// }

// const getPOIIcon = (type: string) => {
//   return Leaflet.icon({
//     iconUrl: `${baseUrl}map_icons/type${type}.svg`,
//     iconSize: [30, 40],
//   });
// };

function App() {
  const { Jsdc, trailQuery, advanceListingQuery, trailClickEvent } = useContext(JSDCContext);
  const [openCard, setOpenCard] = useState(false);
  const [cardProps, setCardProps] = useState<ITrailCardProps>({});
  const { openDialog, setOpenDialog, featureProperties, featureColor, featureIcon } =
    useContext(JSDCContext);
  const handleCloseDialog = () => setOpenDialog(false);

  const displayName: Record<string, string> = {
    occurrence_id: '河溪名稱',
    created: '回報資料建立時間',
    modified: '回報資料修改時間',
    occurrence_photo_url: '回報資料照片網址',
    processing_status: '處理狀態',
    trail_name: '流域名稱',
    other_location_info: '其他地點資訊補充',
    report_date: '回報日期',
    report_time: '回報時間',
    latitude_y: '緯　　度',
    longitude_x: '經　　度',
    occurrence_url: '回報頁面網址',
    occurrence: '回報人員',
    occurrence_status_Y: '回報狀況-沒見到此狀況',
    occurrence_status_N: '回報狀況-問題還在',
  };
  const addtrailsLayerToControl = async () => {
    await Jsdc.asyncViewer;
    const layerController = Jsdc.Controller.get('Layer');
    const layer = trailQuery.trailsLayer;
    layerController.add(layer, { hidden: true, addToMap: true });
    layerController.add(advanceListingQuery.advanceListingLayer, {
      hidden: true,
      addToMap: true,
    });
  };

  const handleTralClick = async (properties?: GeoJsonProperties) => {
    if (!properties) return;
    const needToShow = [
      'occurrence_photo_url',
      'report_date',
      'report_time',
      'latitude_y',
      'longitude_x',
      'trail_name',
      'occurrence',
    ];
    const { city, town } = await getCityAndTown(
      Number(get(properties, 'longitude_x')),
      Number(get(properties, 'latitude_y')),
    );

    setCardProps({
      title: get(properties, 'occurrence_id', '未命名'),
      region: `${city} ${town}`,
      additionals: mapKeys(pick(properties, needToShow), (value, key) =>
        get(displayName, key, key),
      ),
      link: get(properties, 'occurrence_url'),
      category: get(properties, 'listing_category', ''),
    });
    setOpenCard(true);
  };

  useEffect(() => {
    fetch(`https://service.jsdc.com.tw/api/data`);
    addtrailsLayerToControl();
    trailClickEvent.addEventListener(handleTralClick);
  }, []);

  return (
    <div className="root">
      <DguideWalksApp />
      <ResponsiveDialog className="Popup-Custom" open={openCard} onClose={() => setOpenCard(false)}>
        <TrailCard {...cardProps} />
      </ResponsiveDialog>
      {/* what the fuck is this Shit */}
      <ResponsiveDialog
        // className="Popup-Custom"
        open={openDialog}
        onClose={handleCloseDialog}
        Icon={
          <div className="cat-icon" style={{ background: featureColor }}>
            <i className={`las ${featureIcon}`} />
          </div>
        }
        title={Object.entries(featureProperties)
          .map(([key, value]) => (key === '名稱' ? value : null))
          .join('')}
      >
        <DialogContent
        //  className="TrailCard-Root"
        >
          {featureProperties?.社群照片 && (
            <img
              src={featureProperties.社群照片}
              alt={featureProperties.名稱 ?? ''}
              style={{
                maxWidth: '100%',
                height: 'auto',
                display: 'block',
                margin: '0 auto 12px',
              }}
            />
          )}
          {Object.entries(featureProperties).map(([key, value]) => {
            // 過濾掉 null 值和名稱（名稱已在標題顯示）；社群照片已於頂部以 img 呈現
            if (value === null || key === '名稱' || key === '社群照片') return null;

            // 定義欄位顯示名稱
            const fieldLabels: Record<string, string> = {
              編號: '編號',
              構造物類型: '構造物類型',
              河溪名稱: '河溪名稱',
              流域: '流域',
              河岸: '河岸',
              '管轄單位（水利署）': '管轄單位（水利署）',
              資料更新日期: '資料更新日期',
              備註: '備註',
              // 保留舊的欄位
              ele: '高程',
              time: '時間',
              cover1: '純自然鋪面比例',
              cover2: '水泥化比例',
            };

            const label = fieldLabels[key] || key;

            if (key === '社群連結') {
              return (
                <DialogContentText key={key}>
                  {`${label}：`}
                  <a href={String(value)} target="_blank" rel="noopener noreferrer">
                    {String(value)}
                  </a>
                </DialogContentText>
              );
            }

            // 特殊格式處理
            if (key === 'cover1' || key === 'cover2') {
              return <DialogContentText key={key}>{`${label}：${value}％`}</DialogContentText>;
            }

            return <DialogContentText key={key}>{`${label}：${value}`}</DialogContentText>;
          })}
        </DialogContent>
      </ResponsiveDialog>
    </div>
  );
}

const AppWrapper = () => {
  const [Jsdc] = useState(
    new JSDC(EVENT_ID, {
      center: [23.73, 120.97],
      zoom: 8,
      maxZoom: 20,
    }),
  );

  // 景點定位處理函式
  const handleSceneTargetClick = (article: Article) => {
    try {
      // 檢查地圖觀看器是否已初始化
      if (!Jsdc?.viewer) {
        console.warn('Map viewer not initialized');
        return;
      }

      const { id, title, latitude, longitude } = article;

      // 驗證座標
      if (
        latitude === undefined ||
        longitude === undefined ||
        isNaN(latitude) ||
        isNaN(longitude)
      ) {
        console.info(`Scene "${title}" (id: ${id}) has no valid coordinates`);
        return;
      }

      // 飛到景點位置
      Jsdc.viewer.flyTo(latLng(latitude, longitude), 17, { duration: 2 });
    } catch (error) {
      console.error('Error in handleSceneTargetClick:', error);
    }
  };

  const duiConfigProps: IDuiContextProviderProps = {
    sidebarTitle: '',
    sidebarSubtitle: '',
    aboutWalkImgSrc,
    aboutWalkContent,
    credit,
    creditHref: 'https://www.tmitrail.org.tw/',
    headerMBImgSrc,
    headerDImgSrc,
    menuSwitchItems: [{ id: '數位集章', name: '數位集章' }],
    weatherConfig: {
      token: 'CWB-232A270E-12F1-4381-B9F2-DF2D2670A077',
      locations: [
        { county: '新北市', town: '三峽區' },
        { county: '新北市', town: '新店區' },
        { county: '臺北市', town: '文山區' },
      ],
    },
    legendConfig: {
      activeLegends: ['工程擾動', '水質污染', '河川構造物', '河溪樣貌', '其它事件'],
    },
    themeConfig: {
      '--dui-primary': '#28a7e1',
      '--dui-accent': '#8fb257',
      '--dui-secondary': '#2A2E3C',
      '--dui-bg-secondary': '#28a7e1',
      '--dui-bg-accent': '#49303A',
    },
    onSceneTargetClick: handleSceneTargetClick,
    onSceneNavigate: handleSceneNavigate,
    sceneCardsReducer: (data) => data, // 不篩選，顯示所有
  };

  return (
    <JSDCProvider Jsdc={Jsdc}>
      <DguidewalksProvider
        Jsdc={Jsdc}
        layersHiddenFromUI={[]}
        layersShowOnMapByDefault={['臺灣通用電子地圖(等高線+門牌)']}
        config={config}
        articleParser={articleParser}
      >
        <DuiContextProvider {...duiConfigProps}>
          <App />
        </DuiContextProvider>
      </DguidewalksProvider>
    </JSDCProvider>
  );
};

export default AppWrapper;
